import { IState } from 'shared/store';

export const getNewbuildingName = (state: IState): string => {
  return state.offerData.offer.newbuilding.name;
};
